import $ from "jquery";

export class SliderModule {


	constructor(event, slick, statement, currentSlide, nextSlide) {
		statement === "init"
			? this.handleInit(slick)
			: (statement === "beforeChange"
				? this.handleBeforeChange(slick, currentSlide, nextSlide)
				: (statement === "afterChange"
					? this.handleAfterChange(slick)
					: this.slider()));
	}
	private slider = () => {

		const slider = document.querySelector(".slider");

		setTimeout(() => {
			slider.setAttribute("style", "opacity: 1;");
		}, 800);
	}

	// tslint:disable-next-line: no-empty
	handleInit(slick) { }

	private handleAfterChange(slick) {
		for (let i = 0; i < slick.$slides.length; i++) {

			const $slide = $(slick.$slides[i]);

			if ($slide.hasClass("forwards") && $slide.hasClass("slick-current")) {
				$slide.removeClass("forwards");
				$slide.addClass("forwards--after");
			} else if ($slide.hasClass("backwards") && $slide.hasClass("slick-current")) {
				$slide.removeClass("backwards");
				$slide.addClass("backwards--after");
			} else {
				$slide.removeClass("backwards");
				$slide.removeClass("forwards");
			}
		}
	}

	private handleBeforeChange(slick, currentSlide, nextSlide) {
		$(".slick-slide").removeClass("backwards--after");
		$(".slick-slide").removeClass("forwards--after");

		let movingForwards: boolean = false;

		// Set moving forwards to true, if  moving from last to first of slick slideshow
		if (currentSlide === slick.$slides.length - 1 && nextSlide === 0) {
			movingForwards = true; // Set moving forwards to false, if moving from first to last
		} else if (currentSlide === 0 && nextSlide === slick.$slides.length - 1) {
			movingForwards = false;
		} else if (currentSlide < nextSlide) { // Set movingforwards to true - if next slide index is larger than the current
			movingForwards = true;
		} else if (nextSlide < currentSlide) { // Set moving forwards to false, if next slide is smaller than the current.
			movingForwards = false;
		}

		if (movingForwards) {
			$(".slick-slide").addClass("forwards");
		} else if (movingForwards === false) {
			$(".slick-slide").addClass("backwards");
		}
	}

	// if needed without vue can methods be converted to plain jquery,
	// events can be seen here: https://kenwheeler.github.io/slick/
	// any questions, ask Anders Bootsmann.
}
